import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Chip, Typography } from "@material-ui/core";
import { ordenarPuntosDeControlDatos } from "../../../reports/reportsLogic";
import FormDialog from "../../../Modals/FormDialog";
import AtleteDetailsContainer from "../../../reports/atleteDetail/AtleteDetailContainer";

// Un mismo punto de control físico puede tener varias modalidades/vueltas,
// cada una con su propio ID de "control" (kNroPunto*1000+lap) en
// eventResults. Se listan todos para poder juntar los registros de todas
// en un solo feed. Las vueltas de meta (tipoControl 3) usan el ID 0.
function obtenerControlIdsDelPunto(kPuntoControl) {
  const ids = [];
  const modalidadesControl = kPuntoControl.modalidadesPuntoDeControl;
  for (var e in modalidadesControl) {
    var laps = modalidadesControl[e].laps;
    for (var f in laps) {
      var controlId =
        laps[f].tipoControl === 3
          ? 0
          : kPuntoControl.kNroPunto * 1000 + laps[f].lap;
      if (ids.indexOf(controlId) === -1) {
        ids.push(controlId);
      }
    }
  }
  return ids;
}

// Separado a propósito de TimingRegistryContainer: suscribirse a
// eventResults (TODO el array de resultados del evento) hace que el
// componente se re-renderice con cada resultado que llega de CUALQUIER
// punto de control del evento, no solo el de acá. Al vivir en un
// componente aparte que solo se monta cuando el juez abre "Mostrar", la
// pantalla de captura de números (el teclado, lo que se usa todo el
// tiempo) deja de re-renderizarse por resultados que no le importan —
// mientras este panel está cerrado, TimingRegistryContainer ya ni
// siquiera está suscrito a eventResults.
export default function RegistrosTiempoRealPanel({ kPuntoControl, eventDetail }) {
  const eventResults = useSelector((state) => state.events.eventResults);

  const registrosTiempoReal = useMemo(() => {
    if (!eventResults) return [];
    const controlIds = obtenerControlIdsDelPunto(kPuntoControl);
    const porNumero = {};
    controlIds.forEach((controlId) => {
      const { JsonKPC } = ordenarPuntosDeControlDatos(
        false,
        eventResults,
        controlId,
        false
      );
      JsonKPC.forEach((registro) => {
        const existente = porNumero[registro.num];
        if (!existente || registro.fechaHora > existente.fechaHora) {
          porNumero[registro.num] = registro;
        }
      });
    });
    return Object.values(porNumero)
      .sort((a, b) => (a.fechaHora < b.fechaHora ? 1 : -1))
      .slice(0, 30);
  }, [eventResults, kPuntoControl]);

  return (
    <div
      style={{
        display: "flex",
        overflowX: "auto",
        gap: 8,
        paddingBottom: 5,
        marginTop: 8,
      }}
    >
      {registrosTiempoReal.length === 0 && (
        <Typography variant={"body2"} align="center" style={{ width: "100%" }}>
          Sin registros aún
        </Typography>
      )}
      {registrosTiempoReal.map((registro) => {
        const colorGenero =
          registro.gen === "V"
            ? { backgroundColor: "#d32f2f", color: "#fff" }
            : registro.gen === "F"
            ? { backgroundColor: "#f8bbd0", color: "#000" }
            : {};
        return (
          <FormDialog
            key={registro.num + "-" + registro.fechaHora}
            buttomLabel={
              <Chip
                label={registro.num}
                style={{
                  fontSize: 18,
                  height: 40,
                  flexShrink: 0,
                  ...colorGenero,
                }}
              />
            }
            ShowIcon={false}
            ButtonStyle={{
              padding: 0,
              minWidth: 0,
              backgroundColor: "transparent",
              boxShadow: "none",
            }}
            maxWidthProp={"lg"}
            style={{ minHeight: "80vh", maxHeight: "80vh" }}
            report={
              <AtleteDetailsContainer
                eventDetail={eventDetail}
                resultado={{ num: registro.num }}
              />
            }
          />
        );
      })}
    </div>
  );
}
